module.exports = __webpack_public_path__ + "img/content02.90fc3814.png";